export default __webpack_public_path__ + "static/media/search-module.efe0c15e.png";